<template>
  <div class="hello">
    <header>
      <div class="logo">
        
        <a href=""><img src="/logo-taskbloc.png" alt="TaskBloc" class="logo inline"><small>BETA</small></a>
      </div>
      <div class="nav-links">
        <ul>
          <li><a href="https://app.taskbloc.com/login" target="_self" rel="noopener">Login</a></li>
          <li><a href="https://app.taskbloc.com/register" target="_self" rel="noopener">Register</a></li>
        </ul>
      </div>
     </header>
     <div class="message-wrapper">
        <div class="main-message">
          <h1>I am TaskBloc<br>nice to meet you</h1>
          <h3>a smarter way to track your tasks</h3>
        </div>
    </div>
    <footer>
      &copy; 2020 TaskBloc - All Rights Reserved
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
  display: flex;
  position: relative;
  min-width: 400px;
  align-items: center;
  padding: 0 1em;
  border-bottom: 1px solid #c8c8cd;
  padding: 0;
  min-height: 60px;
  margin: 0 20px;
  top: -1px;
}
footer {
  font-size: 12px;
  padding: 12px 0;
  margin: 0 20px;
}
h1 {
  font-size: 4em;
  font-weight: 600;
  margin: 0 0 40px 0;
  line-height: 1.1em;
}
h3 {
  font-weight: 500;
  font-size: 1.4em;
  line-height: 1.1em;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
  text-decoration: none;
  color: #2c3e50;
}
a:hover {
  color: #111;
}
.hello {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.message-wrapper {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
.main-message {
  text-align: left;
  padding: 0 3em;
  align-items: center;
}
.logo {
  display: flex;
  max-width: 300px;
  font-size: 18px;
}
.nav-links {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
}
.nav-links ul {
  display: flex;
  margin: 0;
}
.nav-links li {
  margin: 0;
  margin-left: 20px;
  padding: 0;
}
.nav-links ul li:last-child {
  margin-right: 0;
}
.inline {
  display: inline;
}
.logo {
  max-height: 16px;
  margin-right: .25em;
}
</style>
